<h2 class="self-exclusion__title typography-small-title font-bold">
  Self Exclusion
</h2>
<p class="self-exclusion__description">
  On TF2Hunt, we allow you to temporarily self exclude from the website, this
  means that you will not be able to play on any of our gamemodes, deposit and
  withdraw, claim rakeback, faucet, daily cases, wager goals, rain, supply drop,
  tips. By self-excluding, you agree that this action is not reversible, if you
  wish to get a permanent ban, please contact our support.
</p>
<div
  [(ngpRadioGroupValue)]="banDuration"
  ngpRadioGroup
  class="flex flex-col gap-8"
>
  <span>Ban Duration</span>
  <div class="flex items-center gap-4 flex-wrap">
    @for (item of banDurationOptions; track $index) {
    <button
      class="button h-36 padding-16 rounded-4"
      style="--button-height: var(--size-36)"
      ngpRadioItem
      ngpRadioItemValue="{{ item.key }}"
    >
      {{ item.value }}
    </button>
    }
  </div>
</div>
<div class="self-exclusion__checkbox flex items-center gap-8">
  <app-checkbox [(checked)]="isUnderstandSelfExclusion">
    I understand that staff CANNOT LIFT this ban
  </app-checkbox>
</div>
<button
  class="self-exclusion__button button h-38 w-full button--style-yellow h-38 rounded-4"
  style="--button-height: var(--size-38)"
  [disabled]="!isUnderstandSelfExclusion()"
  (click)="handleSelfExclusion()"
>
  Self exclude for
  {{ currentOption()?.value }}
</button>
